import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';

export interface ShipmentCarrier {
  id: string;
  name: string;
}

interface ShipmentCarriersState {
  carriers: ShipmentCarrier[];
  loading: boolean;
  error: string | null;
}

const initialState: ShipmentCarriersState = {
  carriers: [],
  loading: false,
  error: null,
};

const shipmentCarriersSlice = createSlice({
  name: 'shipmentCarriers',
  initialState,
  reducers: {
    setShipmentCarriers: (state, action: PayloadAction<ShipmentCarrier[]>) => {
      state.carriers = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setShipmentCarriers, setLoading, setError } =
  shipmentCarriersSlice.actions;

// Selectors
export const selectShipmentCarriers = (state: RootState) =>
  state.shipping.shipmentCarriers.carriers;
export const selectShipmentCarriersLoading = (state: RootState) =>
  state.shipping.shipmentCarriers.loading;
export const selectShipmentCarriersError = (state: RootState) =>
  state.shipping.shipmentCarriers.error;

export default shipmentCarriersSlice.reducer;
